import React, { useEffect, useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import useLocalization from 'hooks/useLocalization'
import asideModalStore from 'Stores/asideModalStore'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import styles from './Leads.module.scss'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import { LeadCard } from './LeadCard/LeadCard'
import LeadButtonFilter from './LeadButtonFilter/LeadButtonFilter'
import Details from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/Details/Details'
import { superAxiosRequest } from 'axiosApi'
import LeadChat from './LeadChat/LeadChat'
import AddNewDeal from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddNewDeal/AddNewDeal'
import { observer } from 'mobx-react'
import Loader from 'components/UI/Loader/Loader'
import { useHistory } from 'react-router-dom'

const Leads = () => {
  const [leads, setLeads] = useState([])
  const [statusLeads, setStatusLeads] = useState([])
  const [totalLead, setTotalLead] = useState([])
  const [filter, updateFilter] = useLocalStorageFilter()
  const [openModal, setOpenModal] = useState(false)
  const [chats, setChats] = useState([])
  const [client, setClient] = useState('')
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [currentLead, setCurrentLead] = useState(null)
  const [messages, setMessages] = useState([])
  const history = useHistory()

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
    },
  })

  const filterCfg = [
    {
      label: 'Name',
      nameState: 'client_name',
      type: 'input',
      placeholder: `Name`,
    },
    {
      label: 'Phone',
      nameState: 'client_phone',
      type: 'input',
      placeholder: `+7 (___) ___ - ____`,
    },
    {
      label: 'Lead number',
      nameState: 'lead_name',
      placeholder: 'Lead number',
      type: 'input',
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Date of creation',
    },
  ]

  const fetchLead = () => {
    const queryParams = { ...filter }
    superAxiosRequest({
      link: 'integration/leads',
      method: 'get',
      crm: true,
      params: queryParams,
    })
      .then((response) => {
        setTotalLead(response.data.total)
        setLeads(response.data.result)
      })
      .catch(() => {})
  }

  useEffect(() => {
    fetchLead()
    superAxiosRequest({
      link: 'integration/lead_statuses',
      method: 'get',
      crm: true,
    }).then((response) => {
      const statusesArray = Object.values(response.data)
      setStatusLeads(statusesArray)
    })
  }, [filter])

  // пока оставлю
  // const fetchLead = useCallback(() => {
  //     const queryParams = { ...filter };
  //     superAxiosRequest({
  //         link: 'integration/leads',
  //         method: 'get',
  //         crm: true,
  //         params: queryParams
  //     }).then(response => {
  //         setTotalLead(response.data.total)
  //         setLeads(response.data.result);
  //     }).catch(() => {});
  // }, [filter]);
  //
  // useEffect(() => {
  //     fetchLead();
  //     superAxiosRequest({
  //         link: 'integration/lead_statuses',
  //         method: 'get',
  //         crm: true
  //     }).then((response) => {
  //         const statusesArray = Object.values(response.data);
  //         setStatusLeads(statusesArray);
  //     });
  // }, [filter, fetchLead]);

  const details = (lead) => {
    const ms = {
      modalBodyComponent: () => <Details />,
      button: 'Save',
      link: `integration/leads_client/${lead.id}`,
      title: 'Details',
      is_put: true,
      crm: true,
      isResponsive: true,
      onSubmitSuccess: (upData) => {
        setLeads((prevLeads) =>
          prevLeads.map((lead) =>
            lead.id === upData.id
              ? {
                  ...lead,
                  ...upData,
                  client: { ...lead.client, ...upData.client },
                }
              : lead,
          ),
        )
      },
      valid: {
        name: 'required',
        email: 'required',
        phone: 'required',
      },
    }
    const md = {
      client: lead.client.id,
      name: lead.client.name,
      email: lead.client.email,
      phone: lead.client.phone,
      lead_name: lead.lead_name,
      comment: lead.comment,
      program: lead.program,
      status_lead: lead.status_lead_id,
    }
    asideModalStore.activity(ms, md)
  }

  const addNewDeal = (lead) => {
    const ms = {
      modalBodyComponent: () => <AddNewDeal />,
      button: 'Save',
      link: 'integration/deals',
      title: 'Creating a new deal',
      isResponsive: true,
      crm: true,
      onSubmitSuccess: () => {},
      valid: {
        manager: 'required',
        client: 'required',
        budget: 'required',
        city: 'required',
        branch: 'required',
        program: 'required',
        level: 'required',
      },
    }
    const md = {
      client: lead.client.id,
      lead: lead.id,
    }
    asideModalStore.activity(ms, md)
  }

  const handleDragEnd = (result) => {
    const { source, destination, draggableId } = result
    if (!destination) {
      return
    }
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return
    }

    const newLeadData = Array.from(leads)
    const movedLead = newLeadData.find(
      (lead) => lead.id === parseInt(draggableId),
    )
    if (!movedLead) return

    movedLead.status_lead_id = parseInt(destination.droppableId)
    setLeads(newLeadData)

    superAxiosRequest(
      {
        link: `integration/leads/${draggableId}`,
        method: 'put',
        crm: true,
      },
      {
        id: movedLead.id,
        client: movedLead.client.id,
        comment: movedLead.comment,
        lead_name: movedLead.lead_name,
        created_at: movedLead.created_at,
        program: movedLead.program_id,
        status_lead: movedLead.status_lead_id,
      },
    )
      .then(() => {
        fetchLead()
      })
      .catch(() => {})
  }

  const handleChat = (lead) => {
    setOpenModal(!openModal)
    if (openModal) {
      setChats([])
    } else {
      setCurrentLead(lead)
      setClient(lead.client.name)
      const apiConf = {
        method: 'get',
        link: `integration/messages`,
        crm: true,
        params: {
          lead_id: lead.id,
        },
      }
      superAxiosRequest(apiConf)
        .then((res) => {
          setMessages(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/crm/leads') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  return (
    <div className={styles.container}>
      <div className={styles.leadHeader}>
        <PageHeader title='Leads'></PageHeader>
        <div className={styles.search}>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, search: text })
              changeTextValue('search', {
                key: 'search',
                label: 'Search',
                value: text,
              })
            }}
            onClear={() => {
              const { search, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'search'),
              )
            }}
            translate={translate}
            placeholder={`Search...`}
            value={filter?.search || ''}
          />

          {!!filterTextValues.length && (
            <FilterTextValues
              onDelete={(key) => {
                const { [key]: _, ...obj } = filter
                updateFilter(obj)
              }}
            />
          )}

          {isOpenFilter && (
            <AsideFilter
              translate={translate}
              getFilterParams={(e) => updateFilter(e)}
              config={filterCfg}
              filterValue={filter}
              onDropFilter={() => {
                updateFilter({})
                closeFilter()
              }}
            />
          )}
        </div>
        <LeadButtonFilter
          leads={leads}
          totalLead={totalLead}
          statusLeads={statusLeads}
        />
      </div>

      {openModal && (
        <LeadChat
          leads={leads}
          chats={chats}
          setChats={setChats}
          handleChat={handleChat}
          client={client}
          setMessages={setMessages}
          messages={messages}
          currentLead={currentLead}
        />
      )}
      {leads.length === 0 ? (
        <Loader />
      ) : (
        <DragDropContext onDragEnd={handleDragEnd}>
          <div className={styles.cardsColumnsContainer}>
            <div className={styles.cardsColumns}>
              {Object.values(statusLeads).map((status) => (
                <Droppable key={status.id} droppableId={status.id.toString()}>
                  {(provided) => (
                    <div
                      className={styles.cardsColumn}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      <div
                        className={styles.columnHeader}
                        style={{
                          backgroundColor: status.color.body_color || '#FFFFFF',
                        }}
                      >
                        <div className={styles.columnName}>{status.name}</div>
                        <div className={styles.countTask}>
                          {
                            leads.filter(
                              (lead) => lead.status_lead_id === status.id,
                            ).length
                          }{' '}
                          Cards
                        </div>
                      </div>
                      {leads
                        .filter((lead) => lead.status_lead_id === status.id)
                        .map((lead, index) => (
                          <Draggable
                            key={lead.id}
                            draggableId={lead.id.toString()}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <LeadCard
                                  {...lead}
                                  statusLeads={statusLeads}
                                  details={() => details(lead)}
                                  openModal={() => handleChat(lead)}
                                  addDeal={() => addNewDeal(lead)}
                                />
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ))}
            </div>
          </div>
        </DragDropContext>
      )}
    </div>
  )
}
export default observer(Leads)
